<template>
  <div class="table">
    <div class="table-header">
      <div class="row sharedRecDetails">
        <div>
          <span class="column extra-short-column">
              <label class="checkbox-wrapper">
                <input type="checkbox" v-model="allChecked" @change="checkAll">
                <span class="checkmark"></span>
              </label>
            </span>
          <span class="column pointer" @click="sort('originalPayments.paymentDate')">
              <span> {{ $lang.messages.date }} </span>
              <img
                  src="@/assets/images/payments/arrow_down_small.png"
                  class="sort-indicator-down"
                  :class="{ 'sort-indicator-up': 'desc' === currentSortDir && 'originalPayments.paymentDate' === currentSort }"
              />
            </span>
          <span class="column pointer" @click="sort('originalPayments.amount')">
              <span> {{ $lang.messages.amount }} </span>
              <img
                  src="@/assets/images/payments/arrow_down_small.png"
                  class="sort-indicator-down"
                  :class="{ 'sort-indicator-up': 'desc' === currentSortDir && 'originalPayments.amount' === currentSort }"
              />
            </span>
        </div>
        <div>
            <span class="column column-middle pointer" @click="sort('reimbursementPayments.paymentDate')">
              <span> {{ $lang.messages.date }} </span>
              <img
                  src="@/assets/images/payments/arrow_down_small.png"
                  class="sort-indicator-down"
                  :class="{ 'sort-indicator-up': 'desc' === currentSortDir && 'reimbursementPayments.paymentDate' === currentSort }"
              />
            </span>
          <span class="column column-middle pointer" @click="sort('reimbursementPayments.amount')">
              <span> {{ $lang.messages.amount }} </span>
              <img
                  src="@/assets/images/payments/arrow_down_small.png"
                  class="sort-indicator-down"
                  :class="{ 'sort-indicator-up': 'desc' === currentSortDir && 'reimbursementPayments.amount' === currentSort }"
              />
            </span>
          <span class="column column-middle pointer">
              <span> {{ $lang.messages.status }} </span>
            </span>
          <span class="column short-column actions-ico">
            <span>{{ $lang.messages.actions }}</span>
          </span>
        </div>
      </div>
    </div>
    <div
        v-if="list.length !== 0"
        class="table-body"
    >
      <div
          v-for="(expense, indexRecShared) in list"
          :key="indexRecShared"
          class="row sharedRecDetails pointer"
          @click="showDetails(expense, $event)"
      >
        <div>
          <span class="column extra-short-column">
          <label class="checkbox-wrapper" :class="{'disabled' : expense.payable === false}">
            <input
                type="checkbox"
                v-model="expense.isChecked"
                :disabled="!expense.payable"
                @change="shareCheckedExpenses(expense)"
            >
            <span class="checkmark"></span>
          </label>
        </span>

          <div class="column">
            <div class="column-name"> {{ $lang.messages.date }} </div>
            <span class="column-data" :title="dateFormat(expense.originalPaymentDate)"> {{ dateFormat(expense.originalPaymentDate)}} </span>
          </div>

          <div class="column bold-column">
            <div class="column-name"> {{ $lang.messages.amount }} </div>
            <span class="column-data">
              <currency-sign :currency="expense.currency"></currency-sign>{{ currencyFormat(expense.originalAmount) }}
            </span>
          </div>
        </div>

        <div>
          <div class="column column-middle">
            <div class="column-name"> {{ $lang.messages.date }} </div>
            <span class="column-data" :title="dateFormat(expense.reimbursementPaymentDate)"> {{ dateFormat(expense.reimbursementPaymentDate)}} </span>
          </div>

          <div class="column column-middle bold-column">
            <div class="column-name"> {{ $lang.messages.amount }} </div>
            <span class="column-data">
              <currency-sign :currency="expense.currency"></currency-sign>{{ currencyFormat(expense.reimbursementAmount) }}
            </span>
          </div>

          <div class="column column-middle">
            <div class="column-name"> {{ $lang.messages.status }} </div>
            <span class="column-data">
            <button
              class="lbl"
              :class="
              expense.status.toLowerCase() === 'paid' ?
              'lbl-paid' : expense.status.toLowerCase() === 'pending' ?
              'lbl-pending' :  expense.status.toLowerCase() === 'not_paid' ?
              'lbl-unpaid' : 'lbl-paid'">
              {{
                expense.status.toLowerCase() === 'paid' ?
                '🗸 ' + $lang.messages.paid : expense.status.toLowerCase() === 'pending' ?
                $lang.messages.pending : expense.status.toLowerCase() === 'not_paid' ?
                $lang.messages.notPaid :  expense.status.toLowerCase() === 'digital_check' ?
                '🗸 ' + $lang.messages.digitalCheck : '🗸 ' + $lang.messages.paidExternally
              }}
           </button>
          </span>
          </div>

          <!-- Actions -->
          <div
              class="column short-column center-aligned-column actions-ico"
              id="actions-ico"
              @click="toggleActions(expense.expenseGuid)"
          >
            <img src="@/assets/images/payments/actions_ico.png" />
            <div
                class="action-menu"
                :class="[ actionsRowId === expense.expenseGuid && actions ? 'select-menu-collapsed' : 'select-menu-not-collapsed' ]"
            >
              <router-link
                  v-if="expense.expenseType === $SHARED_EXPENSE_TYPE"
                  :to="{ name: 'ExpenseDetailsSharedExpenses',  params: { id: expense.expenseGuid, expenseStatus: expense.status } }"
              >
                <div class="item">
                  {{ $lang.messages.view }}
                </div>
              </router-link>
              <button
                  id="actions-btn"
                  class="item btn-item"
                  :class="{'disabled': !expense.payable}"
                  :disabled="!expense.payable"
                  @click="showPayExpenseModal(expense)"
              >
                {{ $lang.messages.pay }}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <f-p-pagination :paginationParams="paginationParams" @onPaginationChanged="onPaginationChanged" ></f-p-pagination>

    <!-- Pay Expense modal -->
    <f-p-pay-expense-modal
        :nameProp="'payExpenseTableRecSharedDetails'"
        ref="payExpenseTableRecSharedDetails"
        @loadExpenses="onPaginationChanged">
    </f-p-pay-expense-modal>
  </div>
</template>

<script>
  import CurrencySign from "@/components/common/CurrencySign"
  import FPPayExpenseModal from "@/components/common/modals/FPPayExpenseModal"
  import FPPagination from "./FPPagination"
  import { currencyFormat } from "@/mixins/currencyFormat";
  import {dateFormat} from "@/mixins/dateFormat";

  export default {
    name: "FPTableRecurringDetails",
    components: {
      CurrencySign,
      FPPayExpenseModal,
      FPPagination
    },
    mixins: [
      currencyFormat,
      dateFormat
    ],
    props: {
      list: {
        type: Array,
        required: true,
        default: () => []
      },
      paginationParams: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    data() {
      return {
        actions: false,
        actionsRowId: 0,
        currentSort: "",
        currentSortDir: "ASC",
        allChecked: false,
        checkedList: [],
        checkedExpensesAll: []
      };
    },
    mounted() {
      this.onClickOutside()
      this.setTooltips()
    },
    methods: {
      onClickOutside() {
        let _this = this;
        document.addEventListener('click', function(e) {
          let dropdown = document.querySelector('.select-menu-type-2');
          let clickedElement = e.target;

          if (clickedElement.className.indexOf('item') !== 0) {
            if (clickedElement.className.indexOf('actions-ico') === -1 && clickedElement !== dropdown) {
              _this.actions = false;
            }
          } else {
            _this.actions = !_this.actions;
          }
        });
      },
      setTooltips() {
        let tooltips = document.getElementsByClassName('tooltiptext')

        for (let item of tooltips) {
          let height = item.offsetHeight
          if (height >= 30 && height <= 40) {
            item.style.marginTop = "4px"
          } else if (height >= 41 && height <= 50) {
            item.style.marginTop = "-4px"
          } else if (height >= 51 && height <= 60) {
            item.style.marginTop = "-8px"
          } else if (height >= 61 && height <= 70) {
            item.style.marginTop = "-12px"
          } else if (height >= 71 && height <= 80) {
            item.style.marginTop = "-16px"
          } else if (height >= 81 && height <= 100) {
            item.style.marginTop = "-20px"
          } else if (height >= 101) {
            item.style.marginTop = "-24px"
          }
        }
      },
      toggleActions(guid) {
        this.actions = !this.actions;
        this.actionsRowId = guid;
      },
      sort(param) {
        if (param === this.currentSort) {
          this.currentSortDir = this.currentSortDir === "ASC" ? "DESC" : "ASC";
        }
        this.currentSort = param;
        this.$emit("sort", this.currentSort, this.currentSortDir);
      },
      checkAll() {
        if (this.allChecked) {
          this.list.forEach(element => {
            if (element.payable) {
              element.isChecked = true
              this.shareCheckedExpenses(element)
            }
          });
        } else {
          this.list.forEach(element => {
            if (element.payable) {
              element.isChecked = false
              this.shareCheckedExpenses(element)
            }
          });
        }
      },
      shareCheckedExpenses(element) {
        this.$emit("shareCheckedExpenses", element);
      },
      showPayExpenseModal(expense) {
        this.checkedExpensesAll.push(expense)
        this.$refs.payExpenseTableRecSharedDetails.show(this.checkedExpensesAll);
      },
      onPaginationChanged() {
        this.allChecked = false;
        this.$emit("onPaginationChanged", this.paginationParams);
      },
      showDetails(expense, e) {
        if (e.target.id !== 'actions-ico' && e.target.id !== 'actions-btn') {
          this.$router.push({ name: 'ExpenseDetailsSharedExpenses', params: { id: expense.expenseGuid, expenseStatus: expense.status } })
        }
      },
    }
  };
</script>
